import type REGL from "regl";

export let regl: REGL.Regl;

export const setRegl = (v: REGL.Regl) => regl = v;
